import { NgModule } from '@angular/core';
import { ConferencesConferenceRemindersService } from './services/conferences-conference-reminders.service';

@NgModule({
  providers: [ConferencesConferenceRemindersService],
})
export class ConferencesModule {}
